import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { getModuleDataByModuleName } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import { GallectionType } from '../../../../../types/gallection';
import { AppState } from '../../../../../types/store';
import {
  getProfileGruser,
  getProfileOwnerStat,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';

interface GalleryTierUpsell {
  showTierUpsell: boolean;
  tierCount: number;
  promoDeviation: PapiDeviation | undefined;
}

export function useGalleryTierUpsell(): GalleryTierUpsell {
  const galleryTierEnabled = useFlag('gallery_tier');
  const gallectionType = useSelector(getGallectionSectionType);
  const isGallery = gallectionType === GallectionType.GALLERY;
  const isOwner = useSelector(isCurrentUserProfileOwner);
  const tierCount: number =
    useSelector((state: AppState) => getProfileOwnerStat(state, 'tiers')) ?? 0;
  const gruser = useSelector(getProfileGruser);
  const foldersModuleData = useSelector((state: any) =>
    getModuleDataByModuleName(state, gruser, 'folders')
  );
  const promoDeviation: PapiDeviation | undefined = foldersModuleData?.promo;

  const showTierUpsell =
    galleryTierEnabled && isGallery && !isOwner && tierCount > 0 &&
    !!promoDeviation;

  return { showTierUpsell, tierCount, promoDeviation };
}
